import React, { useState } from 'react';
import { Sparkles, Loader2, AlertTriangle } from 'lucide-react';
import { useT } from '../../utils/translate';
import { useCallAiSettings, useCallBrief, IN_PROGRESS, scoreTone } from '../../utils/callAi';
import CallAnalysisModal from './CallAnalysisModal';

// Значок AI-анализа рядом с записью звонка: «AI» → в очереди → оценка (цвет) / проблемный / ошибка.
// Показывается только если анализ включён в организации и у звонка есть запись состоявшегося разговора.
export default function CallAiBadge({ call }) {
  const t = useT();
  const { settings } = useCallAiSettings();
  const eligible = !!settings?.enabled && call?.status === 'completed' && !!call?.recordingUrl;
  const brief = useCallBrief(call?._id, eligible);
  const [open, setOpen] = useState(false);
  if (!eligible || brief === undefined) return null;

  let body, cls = 'bg-surface-100 text-ink-tertiary hover:bg-primary-50 hover:text-primary-700', title = t('callAI.badge.analyze');
  if (!brief) body = <><Sparkles className="w-3 h-3" />AI</>;
  else if (IN_PROGRESS.includes(brief.status)) { body = <><Loader2 className="w-3 h-3 animate-spin" />AI</>; title = t('callAI.badge.processing'); cls = 'bg-primary-50 text-primary-600'; }
  else if (brief.status === 'failed') { body = <><AlertTriangle className="w-3 h-3" />AI</>; title = t('callAI.badge.failed'); cls = 'bg-red-50 text-red-600'; }
  else if (brief.status === 'done' && brief.score != null) {
    const tn = scoreTone(brief.score);
    body = <>{brief.flagged ? <AlertTriangle className="w-3 h-3" /> : <Sparkles className="w-3 h-3" />}{brief.score}</>;
    cls = `${tn.bg} ${tn.text}`; title = brief.flagged ? t('callAI.badge.problem') : t('callAI.modal.score');
  } else if (brief.status === 'done') { body = <><Sparkles className="w-3 h-3" />AI</>; title = t('callAI.badge.tooShort'); }
  else body = <><Sparkles className="w-3 h-3" />AI</>;

  return (
    <>
      <button type="button" title={title} onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold transition-colors shrink-0 ${cls}`}>{body}</button>
      {open && <CallAnalysisModal callId={call._id} call={call} onClose={() => setOpen(false)} />}
    </>
  );
}
